/* eslint-disable */
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { updateOrderManagementFilter } from '../../redux/actions/adminActions';
import { useDispatch, useSelector } from 'react-redux';

const ThreeMonthRangePicker = (props) => {
    const Dispatch = useDispatch();
    const { tabName } = props;
    const today = new Date();
    const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
    const { OrderManagmentFilter } = useSelector((state) => state.adminReducers);

    useEffect(() => {
        if (sessionStorage.getItem("reloaded")) {
            Dispatch(updateOrderManagementFilter({
                [tabName]: {
                    CurrentPage: 1,
                    FromDate: threeMonthsAgo,
                    ToDate: today,
                }
            }));
            setDateRange([threeMonthsAgo, today])
            sessionStorage.removeItem("reloaded");
        };

        const handleBeforeUnload = () => {
            sessionStorage.setItem("reloaded", "true");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const [dateRange, setDateRange] = useState([
        OrderManagmentFilter[tabName]?.FromDate
            ? new Date(OrderManagmentFilter[tabName]?.FromDate)
            : null,
        OrderManagmentFilter[tabName]?.ToDate
            ? new Date(OrderManagmentFilter[tabName]?.ToDate)
            : null,
    ]);
    const [startDate, endDate] = dateRange;
    const maxRangeInMs = 90 * 24 * 60 * 60 * 1000; // 90 days

    const filterDate = (date) => {
        if (startDate && !endDate) {
            const maxEndDate = new Date(startDate.getTime() + maxRangeInMs);
            return date <= today && date >= startDate && date <= maxEndDate;
        }
        if (!startDate && endDate) {
            const minStartDate = new Date(endDate.getTime() - maxRangeInMs);
            return date <= endDate && date >= minStartDate;
        }
        return date <= today;
    };

    const handleDateChange = (update) => {
        setDateRange(update);
        if (!update[0] && !update[1]) {
            // Both dates cleared
            Dispatch(updateOrderManagementFilter({
                [tabName]: {
                    CurrentPage: 1,
                    FromDate: null,
                    ToDate: null,
                }
            }));
        } else {
            Dispatch(updateOrderManagementFilter({
                [tabName]: {
                    FromDate: update[0] || null,
                    ToDate: update[1] || null,
                }
            }));
        }
    };

    const ResetFunction = () => {
        Dispatch(updateOrderManagementFilter({
            [tabName]: {
                CurrentPage: 1,
                FromDate: threeMonthsAgo,
                ToDate: today,
            }
        }));
        setDateRange([threeMonthsAgo, today])
    };

    return (
        <div className="col-md-3" style={{ width: "25%", paddingRight: "0px" }}>
            <Form.Group className='reset_three_months_date_time'>
                <div className="datepickField min">
                    <DatePicker
                        selectsRange
                        startDate={dateRange[0]}
                        endDate={dateRange[1]}
                        onChange={handleDateChange}
                        maxDate={today}
                        filterDate={filterDate}
                        placeholderText="Select Date Range"
                        isClearable
                    />
                </div>

                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 100 }}
                    overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                        Click to apply the 3-month filter, or refresh the page to reapply it.
                    </Tooltip>}
                >
                    <button type='button' className='btn' onClick={() => ResetFunction()}>
                        <i className='bi bi-arrow-repeat'></i>
                    </button>
                 </OverlayTrigger>
            </Form.Group>
        </div>
    );
};

export default ThreeMonthRangePicker;